export enum Roles {
  Driver = 'driver',
  Patient = 'patient',
  Public = 'public',
  Admin = 'admin',
  Administrator = 'administrator',
}
